module.exports = {
	"id": "BM",
	"name": "Bermuda",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.021228,
			"12": 0.007076,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.014152,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.042456,
			"28": 0.03538,
			"29": 0.014152,
			"30": null,
			"31": null,
			"32": 0.007076,
			"33": 0.014152,
			"34": 0.042456,
			"35": 0.014152,
			"36": 0.014152,
			"37": 0.007076,
			"38": 0.021228,
			"39": 0.127368,
			"40": 0.007076,
			"41": 0.028304,
			"42": 0.028304,
			"43": 0.03538,
			"44": 0.028304,
			"45": 0.021228,
			"46": 0.042456,
			"47": 0.049532,
			"48": 0.077836,
			"49": 1.62748,
			"50": 0.10614,
			"51": 0.346724,
			"52": 0.290116,
			"53": 21.065252,
			"54": 5.193784,
			"55": 0.056608,
			"56": 0.007076,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.014152,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.014152,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.028304,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.007076,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.021228,
			"39": null,
			"40": 0.007076,
			"41": 0.049532,
			"42": 0.084912,
			"43": 0.028304,
			"44": null,
			"45": 0.042456,
			"46": 0.021228,
			"47": 0.134444,
			"48": 0.5307,
			"49": 4.026244,
			"50": 0.03538,
			"51": null,
			"52": null,
			"3.5": 0.014152,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.014152,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.014152,
			"35": 0.007076,
			"36": null,
			"37": 0.03538,
			"38": null,
			"39": null,
			"40": 0.07076,
			"41": 0.007076,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.028304,
			"5": 0.1769,
			"6": 0.084912,
			"7": 0.063684,
			"8": 0.275964,
			"9": 0.367952,
			"10": 2.674728,
			"3.1": null,
			"3.2": null,
			"5.1": 0.431636,
			"6.1": 0.205204,
			"7.1": 0.049532,
			"9.1": 2.059116
		},
		"ios_saf": {
			"8": 0,
			"10": 10.3319917369,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.278435221898,
			"8.1-8.4": 0.514397274355,
			"9.0-9.2": 0.245400534555,
			"9.3": 3.74393123231
		},
		"android": {
			"3": 0,
			"4": 0.0149146666667,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00186433333333,
			"4.1": 0.0537993333333,
			"4.2-4.3": 0.134498333333,
			"4.4": 0.308414,
			"4.4.3-4.4.4": 0.311077333333
		},
		"ie": {
			"6": null,
			"7": 0.021228,
			"8": 0.382104,
			"9": 1.45058,
			"10": 1.0614,
			"11": 20.477944,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0066543435639,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000184842876775
		},
		"edge": {
			"12": 0.127368,
			"13": 1.004792,
			"14": 4.026244
		},
		"ie_mob": {
			"10": 0.0172969014085,
			"11": 0.0704230985915
		},
		"bb": {
			"7": 0.256581,
			"10": null
		},
		"samsung": {
			"0": 4.046816
		},
		"and_uc": {
			"0": 0.020468
		},
		"op_mini": {
			"0": 0.0896528135593
		},
		"and_chr": {
			"0": 8.620412
		},
		"and_ff": {
			"0": 0.011696
		}
	},
	"total": 98.650141
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BM.json
 ** module id = 480
 ** module chunks = 0
 **/